export default __webpack_public_path__ + "static/media/13.740977e0.jpeg";